import store from "./../src/store/index";
import { AxiosResponse } from "axios";
import router from "./../src/router/index";
import Vue from "vue";
import eventTracking from "./EventTracking";

function purgeStore() {
  Vue.nextTick(() => {
    store.commit("set_showOverlay", true);
  });

  store.commit("set_userIsAuthenticated", false);
  store.commit("set_userSessionHash", "");
  store.commit("set_userData", {});
  store.commit("set_showOverlay", false);
  window.localStorage.clear();
  window.sessionStorage.clear();
}

function routeToHome() {
  if (router.currentRoute.path !== "/") {
    window.location.href = "/";
  }
}

// eslint-disable-next-line
export function handle403(response: AxiosResponse) {
  purgeStore();
  eventTracking.stopSendingData();
  store.commit("set_userSessionInvalidated", true);
  routeToHome();
}

// eslint-disable-next-line
export function handle503(response: AxiosResponse) {
  purgeStore();
  store.commit("set_maximoConnectionIssues", true);
  routeToHome();
}
